/*
 * Kozmoz Hall - Frequently Bought Together (<kz-fbt>)
 *
 * Add-ons: Search & Discovery complementary products for this product.
 * Main product: added by clicking the theme's own Add to cart button, so Customily /
 * line-item properties / quantity stay exactly as the shopper set them. Add-ons are
 * only added after the main product lands in the cart (cartUpdate from product-form).
 * If the main add fails or never happens (e.g. personalization not finished), add-ons
 * are NOT added and the shopper sees a short message.
 */
(function () {
  'use strict';
  if (customElements.get('kz-fbt')) return;

  var MAIN_TIMEOUT_MS = 15000; // Customily needs a few seconds to render the production file

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  class KzFbt extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.sectionId = this.dataset.sectionId;
      this.formId = this.dataset.formId;
      this.max = parseInt(this.dataset.max, 10) || 2;
      this.mode = this.dataset.discountMode || 'none';
      this.pct = parseFloat(this.dataset.discountPercent) || 0;
      this.minItems = parseInt(this.dataset.discountMin, 10) || 2;

      try {
        this.main = JSON.parse(this.querySelector('[data-kz-fbt-main]').textContent);
      } catch (e) {
        return;
      }

      var currency = this.dataset.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      try {
        this.fmt = new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency: currency });
      } catch (e) {
        this.fmt = new Intl.NumberFormat('en', { style: 'currency', currency: 'USD' });
      }

      this.listEl = this.querySelector('[data-kz-fbt-list]');
      this.totalEl = this.querySelector('[data-kz-fbt-total]');
      this.compareEl = this.querySelector('[data-kz-fbt-compare]');
      this.saveEl = this.querySelector('[data-kz-fbt-save]');
      this.addBtn = this.querySelector('[data-kz-fbt-add]');
      this.addLabel = this.querySelector('[data-kz-fbt-add-label]');
      this.errorEl = this.querySelector('[data-kz-fbt-error]');

      this.addBtn.addEventListener('click', this.onAdd.bind(this));

      if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
        this.unsubVariant = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (!event || !event.data || event.data.sectionId !== this.sectionId || !event.data.variant) return;
          var v = event.data.variant;
          this.main.variantId = v.id;
          this.main.price = v.price;
          this.main.available = v.available;
          this.refresh();
        });
      }

      this.onQtyChange = (e) => {
        if (e.target && e.target.matches && e.target.matches('input[name="quantity"]') && this.addons) this.refresh();
      };
      document.addEventListener('change', this.onQtyChange);

      this.load();
    }

    disconnectedCallback() {
      if (this.unsubVariant) this.unsubVariant();
      if (this.onQtyChange) document.removeEventListener('change', this.onQtyChange);
    }

    money(cents) {
      return this.fmt.format((cents || 0) / 100);
    }

    load() {
      var url = this.dataset.recUrl + '?product_id=' + encodeURIComponent(this.dataset.productId) +
        '&intent=complementary&limit=' + (this.max + 2);
      fetch(url)
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then((data) => {
          var pid = String(this.dataset.productId);
          this.addons = (data.products || [])
            .filter(function (p) { return p.available && String(p.id) !== pid && !p.requires_selling_plan; })
            .slice(0, this.max)
            .map(function (p) {
              var variants = p.variants.filter(function (v) { return v.available; });
              return { product: p, variants: variants, variant: variants[0], checked: true };
            })
            .filter(function (a) { return !!a.variant; });

          if (!this.addons.length) return; // nothing to suggest: block stays hidden
          return Promise.all(this.addons.map((a) => this.checkPersonalization(a))).then(() => {
            this.render();
            this.hidden = false;
          });
        })
        .catch(function () {});
    }

    /*
     * Add-ons with required Customily options (design swatch, name, face...) cannot be
     * added in one click: Customily must build their preview + production file first.
     * Those rows become a "Personalize" link to the product page instead of a checkbox.
     * If Customily can't be reached we play safe and treat the add-on as personalized.
     */
    checkPersonalization(a) {
      var shop = (window.Shopify && Shopify.shop) || '';
      if (!shop) { a.personalize = false; return Promise.resolve(); }
      var url = 'https://sh.customily.com/api/settings/unified/' + encodeURIComponent(a.product.handle) +
        '?shop=' + encodeURIComponent(shop) + '&productId=' + encodeURIComponent(a.product.id);
      return fetch(url)
        .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
        .then(function (d) {
          var required = (d.sets || []).some(function (s) {
            return (s.options || []).some(function (o) { return o.required && !o.hide_visually; });
          });
          a.personalize = required;
        })
        .catch(function () { a.personalize = true; })
        .then(function () { if (a.personalize) a.checked = false; });
    }

    render() {
      var html = '';
      html += this.rowHtml({
        key: 'main',
        title: this.main.title,
        prefix: 'This item: ',
        image: this.main.image,
        url: null,
        selectHtml: '',
        price: this.main.price,
        checked: true,
      });

      this.addons.forEach((a, i) => {
        var p = a.product;
        var selectHtml = '';
        if (a.personalize) {
          selectHtml = '<a class="kz-fbt__personalize" href="' + esc(p.url) + '">Personalize this item &rarr;</a>';
        } else if (a.variants.length > 1) {
          selectHtml = '<select class="kz-fbt__select" data-kz-fbt-variant="' + i + '" aria-label="' + esc(p.title) + ' options">' +
            a.variants.map(function (v) {
              return '<option value="' + v.id + '">' + esc(v.public_title || v.title) + '</option>';
            }).join('') + '</select>';
        }
        var img = (a.variant.featured_image && a.variant.featured_image.src) || p.featured_image || '';
        html += this.rowHtml({
          key: String(i),
          title: p.title,
          prefix: '',
          image: img,
          url: p.url,
          selectHtml: selectHtml,
          price: a.variant.price,
          checked: a.checked,
          personalize: a.personalize,
        });
      });

      this.listEl.innerHTML = html;

      this.listEl.querySelectorAll('[data-kz-fbt-check]').forEach((cb) => {
        cb.addEventListener('change', () => {
          var k = cb.getAttribute('data-kz-fbt-check');
          if (k === 'main') this.mainChecked = cb.checked;
          else this.addons[parseInt(k, 10)].checked = cb.checked;
          cb.closest('.kz-fbt__item').classList.toggle('is-off', !cb.checked);
          this.refresh();
        });
      });

      this.listEl.querySelectorAll('[data-kz-fbt-variant]').forEach((sel) => {
        sel.addEventListener('change', () => {
          var a = this.addons[parseInt(sel.getAttribute('data-kz-fbt-variant'), 10)];
          a.variant = a.variants.find(function (v) { return String(v.id) === sel.value; }) || a.variant;
          this.refresh();
        });
      });

      this.mainChecked = true;
      this.refresh();
    }

    rowHtml(r) {
      var src = r.image ? String(r.image) : '';
      if (src && src.indexOf('//') === 0) src = 'https:' + src;
      if (src && src.indexOf('width=') === -1 && src.indexOf('cdn.shopify.com') !== -1) {
        src += (src.indexOf('?') === -1 ? '?' : '&') + 'width=160';
      }
      var title = r.url
        ? '<a class="kz-fbt__title" href="' + esc(r.url) + '">' + esc(r.title) + '</a>'
        : '<span class="kz-fbt__title">' + esc(r.prefix) + '<strong>' + esc(r.title) + '</strong></span>';
      var id = 'kz-fbt-' + this.sectionId + '-' + r.key;
      var img = src ? '<img src="' + esc(src) + '" alt="" width="64" height="64" loading="lazy">' : '';
      if (r.personalize) {
        return '<li class="kz-fbt__item kz-fbt__item--personalize">' +
          '<span class="kz-fbt__check-spacer" aria-hidden="true"></span>' +
          '<a class="kz-fbt__media" href="' + esc(r.url) + '" tabindex="-1">' + img + '</a>' +
          '<div class="kz-fbt__info">' + title + r.selectHtml + '</div>' +
          '<span class="kz-fbt__price kz-fbt__price--muted" data-kz-fbt-price="' + r.key + '">' + this.money(r.price) + '</span>' +
        '</li>';
      }
      return '<li class="kz-fbt__item' + (r.checked ? '' : ' is-off') + '">' +
        '<input type="checkbox" class="kz-fbt__check" id="' + id + '" data-kz-fbt-check="' + r.key + '"' + (r.checked ? ' checked' : '') + '>' +
        '<label class="kz-fbt__media" for="' + id + '">' + img + '</label>' +
        '<div class="kz-fbt__info">' + title + r.selectHtml + '</div>' +
        '<span class="kz-fbt__price" data-kz-fbt-price="' + r.key + '">' + this.money(r.price) + '</span>' +
      '</li>';
    }

    mainQty() {
      var q = document.querySelector('input[name="quantity"][form="' + this.formId + '"]') ||
        (document.getElementById(this.formId) || document).querySelector('input[name="quantity"]');
      var n = q ? parseInt(q.value, 10) : 1;
      return n > 0 ? n : 1;
    }

    refresh() {
      var qty = this.mainQty();
      var mainPriceEl = this.querySelector('[data-kz-fbt-price="main"]');
      if (mainPriceEl) mainPriceEl.textContent = (qty > 1 ? qty + ' × ' : '') + this.money(this.main.price);

      var mainOn = this.mainChecked && this.main.available;
      var mainCb = this.querySelector('[data-kz-fbt-check="main"]');
      if (mainCb) mainCb.disabled = !this.main.available;

      var addonTotal = 0;
      var addonCount = 0;
      this.addons.forEach((a, i) => {
        var el = this.querySelector('[data-kz-fbt-price="' + i + '"]');
        if (el) el.textContent = this.money(a.variant.price);
        if (a.checked) { addonTotal += a.variant.price; addonCount += 1; }
      });

      var mainTotal = mainOn ? this.main.price * qty : 0;
      var count = (mainOn ? qty : 0) + addonCount;
      var total = mainTotal + addonTotal;

      var discounted = total;
      if (this.pct > 0) {
        if (this.mode === 'all_items' && count >= this.minItems) {
          discounted = Math.round(total * (1 - this.pct / 100));
        } else if (this.mode === 'addons_only' && mainOn && addonCount >= 1) {
          discounted = mainTotal + Math.round(addonTotal * (1 - this.pct / 100));
        }
      }

      this.totalEl.textContent = this.money(discounted);
      var hasSaving = discounted < total;
      this.compareEl.hidden = !hasSaving;
      this.saveEl.hidden = !hasSaving;
      if (hasSaving) {
        this.compareEl.textContent = this.money(total);
        this.saveEl.textContent = 'Save ' + this.money(total - discounted);
      }

      var tickable = this.addons.filter(function (a) { return !a.personalize; }).length;
      var allOn = mainOn && tickable > 0 && addonCount === tickable;
      var label = allOn ? this.dataset.buttonAllLabel : this.dataset.buttonLabel;
      this.addLabel.textContent = String(label || 'Add {count} to cart').replace('{count}', count);
      this.addBtn.disabled = count === 0;

      // Only personalized add-ons: the block becomes a plain suggestion list.
      var totalRow = this.querySelector('.kz-fbt__total');
      if (totalRow) totalRow.hidden = tickable === 0;
      this.addBtn.hidden = tickable === 0;
      var note = this.querySelector('.kz-fbt__note');
      if (note) note.hidden = tickable === 0;
    }

    showError(msg) {
      this.errorEl.textContent = msg;
      this.errorEl.hidden = !msg;
    }

    setLoading(on) {
      this.addBtn.classList.toggle('loading', on);
      this.addBtn.setAttribute('aria-disabled', on ? 'true' : 'false');
      this.loading = on;
    }

    /* Click the theme's real Add to cart button and wait for product-form's result. */
    addMainViaThemeForm() {
      return new Promise((resolve) => {
        var form = document.getElementById(this.formId);
        // Customily hides the theme's submit button and shows its own #customily-cart-btn.
        // Clicking Customily's button lets it build the preview/production file, then it
        // submits the theme form itself (product-form publishes cartUpdate as usual).
        var cly = document.getElementById('customily-cart-btn');
        var btn = cly && cly.offsetParent !== null ? cly : form && form.querySelector('[type="submit"]');
        if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') {
          resolve({ ok: false, reason: 'unavailable' });
          return;
        }
        var done = false;
        var unsubOk = function () {};
        var unsubErr = function () {};
        var timer = null;
        var poll = null;
        var finish = function (res) {
          if (done) return;
          done = true;
          unsubOk();
          unsubErr();
          clearTimeout(timer);
          clearInterval(poll);
          resolve(res);
        };

        var readCart = function () {
          return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
        };
        var qtyMap = function (cart) {
          var m = {};
          (cart.items || []).forEach(function (i) { m[i.key] = i.quantity; });
          return m;
        };

        readCart().then(function (before) {
          var baseCount = before.item_count || 0;
          var baseQty = qtyMap(before);

          // Signal 1: any cartUpdate (theme form, or Customily submitting it).
          if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
            unsubOk = subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
              finish({ ok: true, cartData: ev && ev.cartData });
            });
            unsubErr = subscribe(PUB_SUB_EVENTS.cartError, function (ev) {
              finish({ ok: false, reason: 'error', message: ev && ev.message });
            });
          }

          // Signal 2 (fallback): the cart itself grew. Find the line that changed.
          poll = setInterval(function () {
            readCart().then(function (now) {
              if ((now.item_count || 0) <= baseCount) return;
              var changed = (now.items || []).find(function (i) { return (baseQty[i.key] || 0) < i.quantity; });
              finish({ ok: true, cartData: changed ? { key: changed.key } : null });
            }).catch(function () {});
          }, 700);

          timer = setTimeout(function () { finish({ ok: false, reason: 'timeout' }); }, MAIN_TIMEOUT_MS);
          btn.click();
        }).catch(function () {
          finish({ ok: false, reason: 'error' });
        });
      });
    }

    refreshCartUi(key) {
      var notif = document.querySelector('cart-notification');
      var bubbleOnly = function () {
        return fetch('/?sections=cart-icon-bubble')
          .then(function (r) { return r.json(); })
          .then(function (s) {
            var el = document.getElementById('cart-icon-bubble');
            if (el && s['cart-icon-bubble']) {
              var doc = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html');
              var wrap = doc.querySelector('.shopify-section') || doc.body.firstElementChild;
              if (wrap) el.innerHTML = wrap.innerHTML;
            }
          })
          .catch(function () {});
      };
      if (!notif || typeof notif.renderContents !== 'function' || typeof notif.getSectionsToRender !== 'function') {
        return bubbleOnly();
      }
      var keyPromise = key
        ? Promise.resolve(key)
        : fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
            return c.items && c.items.length ? c.items[c.items.length - 1].key : null;
          });
      return keyPromise.then(function (k) {
        if (!k) return bubbleOnly();
        notif.cartItemKey = k;
        var ids = notif.getSectionsToRender().map(function (s) { return s.id; });
        return fetch('/?sections=' + encodeURIComponent(ids.join(',')))
          .then(function (r) { return r.json(); })
          .then(function (sections) {
            try { notif.renderContents({ key: k, sections: sections }); } catch (e) { return bubbleOnly(); }
          });
      }).catch(bubbleOnly);
    }

    onAdd() {
      if (this.loading) return;
      this.showError('');

      var extras = this.addons
        .filter(function (a) { return a.checked; })
        .map(function (a) { return { id: a.variant.id, quantity: 1 }; });
      var mainOn = this.mainChecked && this.main.available;
      if (!mainOn && !extras.length) return;

      this.setLoading(true);

      var step = mainOn ? this.addMainViaThemeForm() : Promise.resolve({ ok: true, skipped: true });

      step.then((res) => {
        if (!res.ok) {
          var msg = res.reason === 'timeout'
            ? 'Please finish choosing your options above, then try again.'
            : (res.message || 'This item could not be added. Please check your options above.');
          this.showError(msg);
          return;
        }
        var mainKey = res.cartData && res.cartData.key;
        if (!extras.length) return;

        return fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: extras }),
        })
          .then(function (r) { return r.json(); })
          .then((data) => {
            if (data && data.status) {
              this.showError(data.description || data.message || 'Some items could not be added.');
            }
            return this.refreshCartUi(mainKey);
          });
      })
      .catch(() => {
        this.showError('Something went wrong. Please try again.');
      })
      .finally(() => {
        this.setLoading(false);
      });
    }
  }

  customElements.define('kz-fbt', KzFbt);
})();
